import { toAccountLink } from '@core/external-links/models';

export const DOWNLOAD_APP_ROUTE = '/download/app';

export const SUBS_ROUTE = '/subscriptions';
export const MYMEMBERSHIP_ROUTE = '/mymembership';
export const UPDATE_CARD_ROUTE = '/account/update_card';

export const orderHistoryAccount = toAccountLink('/orderhistory');
export const myMembershipAccount = toAccountLink(MYMEMBERSHIP_ROUTE);

export const toBillingSubscriptionsUrl = () =>
  `${MYMEMBERSHIP_ROUTE}/billing${SUBS_ROUTE}`;
export const toV2BillingSubscriptionsUrl = () => `${MYMEMBERSHIP_ROUTE}/v2${SUBS_ROUTE}`;
export const toSubscriptionsUrl = () => `${MYMEMBERSHIP_ROUTE}${SUBS_ROUTE}`;

export const toV2BillingSubDetailsUrl = (id: string = ':id') =>
  `${toV2BillingSubscriptionsUrl()}/${id}`;

export const toV2BillingSubCancelSuccessUrl = (id: string = ':id') =>
  `${toV2BillingSubDetailsUrl(id)}/cancel-success`;

export const downloadAppSocialProspects = toAccountLink(DOWNLOAD_APP_ROUTE);
